var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#1ED760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.244 16.904V21.464H14.7V16.904L10.5 10H11.86C11.9987 10 12.108 10.0347 12.188 10.104C12.268 10.1733 12.3373 10.2587 12.396 10.36L15.02 14.816C15.1267 15.0027 15.2147 15.1787 15.284 15.344C15.3587 15.5093 15.4253 15.672 15.484 15.832C15.5427 15.6667 15.6067 15.5013 15.676 15.336C15.7453 15.1707 15.8333 14.9973 15.94 14.816L18.556 10.36C18.604 10.2747 18.668 10.1947 18.748 10.12C18.8333 10.04 18.9427 10 19.076 10H20.452L16.244 16.904Z",
    fill: "#09411D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundYes);
export default __webpack_public_path__ + "static/media/ic-round-yes.0d07cebf.svg";
export { ForwardRef as ReactComponent };